import React, { Component } from "react";
import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TextInput,
  Linking,
  Platform,
} from "react-native";
import {
  Flex,
  Margin,
  Helpers,
  appStyles,
  FontFamily,
  pageCover,
  accordion,
  Padding,
  article,
  Typo,
  FontWeight,
  input,
  Colors,
  formStyle,
  button,
} from "../../styles/appStyles";
import { helpers } from "../../utils/helpers";
import apiHelpers from "../../utils/api-helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Cookies from "universal-cookie";
import ErrorModal from "../../components/error-modal";
import { removeUserToken } from "../../../redux/User/user.actions";
import AppHeader from "../../components/app-header";
import AppFooter from "../../components/app-footer";
import CustomImage from "../../components/custom-image";
import getImagePath from "../../utils/image-helper";
import ButtonGradient from "../../components/button-gradient";
import AccordionListItem from "../../components/accordian";
import Seo from "../../components/seo-meta";
import VimeoVideo from "../../components/vimeo-video";
import seoObj from "../../utils/seo-helper";

const cookies = new Cookies();

let SECTIONS = [
  {
    id: 0,
    title: "What is The Morning Context?",
    content:
      "The Morning Context helps you make sense of the world with deeply-reported, impactful and ambitious stories. We are unabashedly an ad-free subscriptions business, almost entirely funded by readers.",
  },
  {
    id: 1,
    title: "What do you write about?",
    content: "There are three pillars to our editorial strategy:",
    data: [
      "Longreads— We write the most ambitious stories on tech companies, public markets, environment and conflict.",
      "Newsletters— A wealth of knowledge from India’s top writers curated for our readers.",
      "Catchup news— We give you a clutter-free recap of everything that is happening around the world with a quick, to-the-point perspective.",
    ],
  },
  {
    id: 2,
    title: "How many stories do you write?",
    content: "We publish at least three stories a day.",
  },
  {
    id: 3,
    title: "Can I read your stories without subscribing?",
    content:
      "We have a free starter plan with which you can read a mix of stories and newsletters. Just sign up and we will credit 100 credits in your account. You can then spend your credits in reading the stories from our curated starter collection. No credit card. No hassle. You can check the tutorial video below to see how to unlock stories using starter credits.",
  },
  {
    id: 4,
    title: "What are credits?",
    content:
      "As an alternative to our subscription plans, you can purchase credits that you can then use to unlock specific articles of your choice. There are two types: Starter credits, which you get for free when you sign up, and Privilege credits, which you buy.",
  },
  {
    id: 5,
    title: "Why should I purchase credits?",
    content:
      "The Morning Context is built to serve just one person, you. While we’d love for you to subscribe to read us, if you aren’t up for it, that’s not a deal-breaker. We believe that as a reader you should have the independence to decide what you want to read—the choice should be yours. That’s why we have the credits plan. You can purchase credits, and spend them in reading what you want.",
  },
  {
    id: 6,
    title: "What are your subscription plans and privileges?",
    content:
      "Our subscription plans, monthly and annual are competitively priced. You can check them out ",
  },
  {
    id: 7,
    title: "Is there an option for a refund?",
    content:
      "We don’t issue refunds. But if there’s something you don’t like we’d certainly like to hear from you. Write to us at ",
  },
  // {
  //     title: 'Can I gift stories to my friends who don’t have your subscription?',
  //     content: 'Of course. Gifting a fixed number of stories every month is a feature of our subscriber plans.',
  // },
  //   {
  //     id: 8,
  //     title:
  //       "I want to purchase the quarterly subscription. Why is it only showing a credit card as the only payment option?",
  //     content:
  //       "Our quarterly subscription only supports recurring payment methods, which are currently limited to cards.",
  //   },
  {
    id: 8,
    title:
      "I am a paying subscriber but I am not getting your daily emails. What can I do?",
    content:
      "Your mail client’s filters may be delivering our emails in your spam or promotions folder. Please check there. Just to be sure that you don’t miss our daily emails, add newsletters@themorningcontext.com to your address book or simply reply to any of our daily emails.",
  },
  // {
  //     title: 'I am a paying subscriber but I am not able to access the stories and your website is asking me to pay again. What can I do?',
  //     content: 'Chances are you are not using your correct email address with which you subscribed. Please sign in using that email address only.',
  // },
  {
    id: 9,
    title: "Can I change my email address?",
    content: "Yes. Just head to your account settings and update your details.",
  },
  {
    id: 10,
    title: "Can I cancel my subscription?",
    content:
      "Yes. You can cancel your subscription in your account settings. (You’ll still receive our daily story summaries.)",
  },
  {
    id: 11,
    title: "How do I download The Morning Context app? ",
    content: "",
  },
];

let iOS_FAQ = [
  {
    title:
      "How to sign in to my existing TMC account using Sign in with Apple?",
    content:
      "To sign in to an existing TMC account using Sign in with Apple, the email address associated with your Apple ID must match the email address associated with the TMC account you're trying to sign in to. You will not be able to sign in to an existing TMC account if you opt to hide your email address during the Sign in with Apple flow.",
  },
  {
    title: "How to disconnect my a Apple ID from my TMC account?",
    content:
      "1. On your iOS or iPadOS device, go to the Settings app.\n2. Select the top option where your name is displayed with Apple ID, iCloud, iTunes & Ap... beneath your name.\n3. Select Password & Security.\n4. Select Apps Using Your Apple ID.\n5. Select The Morning Context.\n6. Select Stop Using Apple ID.",
  },
  {
    title:
      "How to share my email id with TMC to sign in to my existing account?",
    content:
      "In case you sign in to TMC via Apple Sign in but chose to hide your email id, you will not be connected to your existing account.\nTo connect to your existing account, follow the below steps:\n1. Disconnect your Apple ID from the TMC app (refer previous FAQ query on how to disconnect)\n2. Once disconnected, go back to the TMC app on your device.\n3. Select Sign in with Apple.\n4. Select Share My Email.\nIf your Apple ID email address matches the email address on your TMC account, it will connect automatically. You will then be able to use Sign in with Apple going forward.",
  },
];

if (Platform.OS == "ios") {
  SECTIONS = SECTIONS.concat(iOS_FAQ);
}

export class Faq extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    this.state = {
      pageLoader: false,
      showErrorModal: false,
      showUparrow: false,
      footerData: this.props.footerData ? this.props.footerData : false,
    };
  }

  componentDidMount = () => {};

  renderPageHeader = () => {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <View
        style={[
          helpers.isDesktop() ? Margin.mb_7 : Margin.mb_4,
          Helpers.textCenter,
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWeb1200,
          Flex.alignCenter,
          {
            marginTop: helpers.isDesktop() ? 80 : 75,
            paddingHorizontal: helpers.isDesktop() ? 20 : 20,
          },
        ]}
      >
        <Text
          accessibilityRole="header"
          aria-level="1"
          style={[
            Margin.mt_0,
            Margin.mb_2,
            pageCover.title,
            helpers.isDesktop() && pageCover.titleDesktop,
            Helpers.textCenter,
            !helpers.isDesktop() && { fontSize: 28 },
            { color: darkMode ? Colors.lightWhite : "#000000" },
          ]}
        >
          We are here to help you
        </Text>
        <Text
          style={[
            {
              fontSize: helpers.isDesktop() ? 24 : 16,
              lineHeight: helpers.isDesktop() ? 32 : 24,
              letterSpacing: 0.5,
              fontFamily: FontFamily.regular,
              textAlign: "center",
              color: "#000",
            },
            darkMode && { color: Colors.lightWhite },
          ]}
        >
          Browse through the most frequently asked questions
        </Text>
      </View>
    );
  };

  showPageLoader = () => {
    const webView = helpers.isWeb();
    return (
      <View
        style={[
          Flex.justfiyCenter,
          Flex.alignCenter,
          {
            position: webView ? "fixed" : "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: "#ffffff",
          },
        ]}
      >
        <ActivityIndicator size={25} color={"#000000"} />
      </View>
    );
  };

  navigateTo = (link) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen(link);
    } else {
      this.props.navigation.navigate("/pricing");
    }
  };

  renderPageContent = () => {
    const videoId = "492192956?&portrait=0&byline=0&title=0&background=1";
    const videoIdUrl =
      "https://player.vimeo.com/video/492192956?&portrait=0&byline=0&title=0&background=1";
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        <View
          style={[
            {
              backgroundColor: "#FAFAFA",
              paddingVertical: helpers.isDesktop() ? 90 : 20,
            },
            darkMode && { backgroundColor: Colors.darkBlackColorBg },
          ]}
        >
          <View
            style={[
              Helpers.conatinerWeb,
              helpers.isDesktop() && Helpers.conatinerWeb1200,
              Padding.ph_2,
            ]}
          >
            {SECTIONS.map((citem, index) => {
              return (
                <AccordionListItem
                  title={citem.title}
                  index={index}
                  darkMode={darkMode}
                >
                  <Text>{citem.content} </Text>
                  {citem.id == 1 && (
                    <>
                      {citem.data &&
                        citem.data.map((d, i) => {
                          return (
                            <ul>
                              <li>
                                <Text>{d}</Text>
                              </li>
                            </ul>
                          );
                        })}
                    </>
                  )}
                  {citem.id == 6 && (
                    <>
                      <Text
                        style={[{ textDecorationLine: "underline" }]}
                        onPress={() => window.open("/pricing", "_self")}
                      >
                        here
                      </Text>
                      <Text>.</Text>
                    </>
                  )}
                  {citem.id == 7 && (
                    <>
                      <Text
                        style={[{ textDecorationLine: "underline" }]}
                        onPress={() => {
                          let link = "support@themorningcontext.com";
                          let mailUrl =
                            "https://mail.google.com/mail/?view=cm&fs=1&to=";

                          Linking.canOpenURL(link)
                            .then((supported) =>
                              supported
                                ? Linking.openURL(`mailto:${link}`)
                                : window.open(`${mailUrl}${link}`, "_blank")
                            )
                            .catch((err) =>
                              window.open(`${mailUrl}${link}`, "_blank")
                            );
                        }}
                      >
                        support@themorningcontext.com
                      </Text>
                      <Text>.</Text>
                    </>
                  )}
                  {citem.id == 3 && helpers.isWeb() && (
                    <View
                      style={{
                        width: "100%",
                        height: helpers.isDesktop() ? 420 : "auto",
                        paddingTop: helpers.isDesktop() ? 50 : 30,
                      }}
                    >
                      <VimeoVideo videoId={videoId} faq={true} />
                      <Text
                        style={{ marginTop: helpers.isDesktop() ? 100 : 0 }}
                      >
                        Additionally, we publish two free, public interest
                        stories on environment and conflict every week.
                      </Text>
                    </View>
                  )}
                  {citem.id == 3 && !helpers.isWeb() && (
                    <>
                      <VimeoVideo
                        videoId={videoId}
                        videoIdUrl={videoIdUrl}
                        faq={true}
                      />
                      <Text>
                        Additionally, we publish two free, public interest
                        stories on environment and conflict every week.
                      </Text>
                    </>
                  )}
                  {citem.id == 11 && (
                    <View>
                      <View>
                        <Text>
                          Our Android App is{" "}
                          <Text
                            style={[{ textDecorationLine: "underline" }]}
                            onPress={() =>
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.app.themorningcontext",
                                "_blank"
                              )
                            }
                          >
                            here
                          </Text>
                          <Text>.</Text>
                        </Text>
                      </View>
                      <View>
                        <Text>
                          Our iOS App is{" "}
                          <Text
                            style={[{ textDecorationLine: "underline" }]}
                            onPress={() =>
                              window.open(
                                "https://apps.apple.com/in/app/the-morning-context/id1551672701",
                                "_blank"
                              )
                            }
                          >
                            here
                          </Text>
                          <Text>.</Text>
                        </Text>
                      </View>
                    </View>
                  )}
                </AccordionListItem>
              );
            })}
          </View>
        </View>
        {/* <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, { marginBottom: helpers.isDesktop() ? 200 : 70 }, Padding.ph_2]}>
                    <View style={{ marginTop: helpers.isDesktop() ? 140 : 50 }}>

                        <View style={[article.headerWrapper, !helpers.isDesktop() && { marginLeft: -20, marginRight: -20 }]}>
                            <View style={[Flex.alignCenter, Margin.mb_2]}>
                                <View style={[Padding.ph_2, Helpers.titleBgWrap]}>
                                    <View style={[Helpers.borderBottom]}>
                                        <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, { fontSize: helpers.isDesktop() ? 30 : 20 }, { fontFamily: FontFamily.abrilFatface, fontWeight: FontWeight.regular }]}>Couldn't find what you're looking for? </Text>
                                    </View>
                                </View>
                                <View style={[Helpers.titleLine]}></View>
                            </View>
                        </View>

                        <Text style={[pageCover.content, helpers.isDesktop() && pageCover.contentDesktop, { marginBottom: helpers.isDesktop() ? 30 : 20 }]}>Send us your query below</Text>

                        <View style={{ maxWidth: 425, marginLeft: 'auto', marginRight: 'auto', width: '100%' }}>
                            <View style={[input.Wrapper]}>
                                <View style={[{ position: 'relative' }]}>
                                    <Text style={[input.Label]}>Name</Text>
                                    <TextInput
                                        placeholder={''}
                                        placeholderTextColor={Colors.placeholderTextColor}
                                        style={[formStyle.inputBoxStyle, Padding.pt_1, Padding.pb_1]}
                                        onChangeText={(value) => this.onChange(value, 'email')}
                                    />
                                </View>
                            </View>

                            <View style={[input.Wrapper]}>
                                <View style={[{ position: 'relative' }]}>
                                    <Text style={[input.Label]}>Email id</Text>
                                    <TextInput
                                        placeholder={''}
                                        placeholderTextColor={Colors.placeholderTextColor}
                                        style={[formStyle.inputBoxStyle, Padding.pt_1, Padding.pb_1]}
                                        onChangeText={(value) => this.onChange(value, 'email')}
                                    />
                                </View>
                            </View>

                            <View style={[input.Wrapper]}>
                                <View style={[{ position: 'relative' }]}>
                                    <Text style={[input.Label]}>Your Query</Text>
                                    <TextInput
                                        multiline={true}
                                        numberOfLines={6}
                                        placeholder={''}
                                        placeholderTextColor={Colors.placeholderTextColor}
                                        style={[formStyle.textArea, Padding.pt_1, Padding.pb_1, { borderWidth: 1, borderColor: 'rgba(153, 153, 153, 0.5)', borderRadius: 0, outline: 0 }]}
                                        onChangeText={(value) => this.onChange(value, 'email')}
                                    />
                                </View>
                            </View>

                            <View style={{ marginTop: helpers.isDesktop() ? 40 : 20 }}>
                                <ButtonGradient
                                    title={'SEND QUERY'}
                                    rootStyle={{
                                        btnWrapper: button.primaryGradientBtn,
                                        btnText: [button.primaryGradientText, { paddingHorizontal: 40, fontWeight: '400', fontSize: helpers.isDesktop() ? 18 : 16 }],
                                    }}
                                    rounded={false}
                                    fullWidth={true}
                                    darkMode={darkMode}
                                />
                            </View>
                        </View>
                    </View>
                </View> */}
      </>
    );
  };

  renderWebPage = () => {
    return (
      <>
        {this.renderPageHeader()}
        {this.renderPageContent()}
      </>
    );
  };

  renderAppPage = () => {
    const { pageLoader, showErrorModal, showUparrow, footerData } = this.state;
    const webView = helpers.isWeb();
    let redirectSlugs = {
      web: "/faq",
      native: { redirect: "/faq", verifyRedirect: "/faq" },
    };
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let hideHeader = this.props?.route?.params?.hideHeader;

    let data = {
      pageName: "FAQ",
    };

    return (
      <ScrollView>
        {this.renderPageHeader()}
        {this.renderPageContent()}
        <AppFooter
          navigateWeb={(slug) => this.props.navigateToScreen(slug)}
          navigateApp={(slug, params) =>
            this.props.navigation.navigate(slug, params)
          }
          footerData={footerData}
          Breadcrumbs={Breadcrumbs}
        />
      </ScrollView>
    );
  };

  render() {
    const { pageLoader, showErrorModal, showUparrow, footerData } = this.state;
    const webView = helpers.isWeb();
    let redirectSlugs = {
      web: "/faq",
      native: { redirect: "/faq", verifyRedirect: "/faq" },
    };
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let hideHeader = this.props?.route?.params?.hideHeader;

    let data = {
      pageName: "FAQ",
    };
    return (
      <View
        style={[
          webView && { paddingTop: helpers.isDesktop() ? 54 : 56 },
          appStyles.appBg,
          Flex.fill,
          darkMode && appStyles.appBgDark,
        ]}
      >
        <Seo
          data={seoObj.getDefaultSeo(data)}
          url={
            process.browser
              ? window.location.origin + window.location.pathname
              : ""
          }
          page="/faq"
        />

        <AppHeader
          history={this.props.history}
          searchQuery={this.props.searchQuery}
          locationHash={this.props.locationHash}
          navigateWeb={(slug) => this.props.navigateToScreen(slug)}
          navigateApp={(slug, params) =>
            this.props.navigation.navigate(slug, params)
          }
          redirectSlugs={redirectSlugs}
          goBack={() => this.props.navigation.goBack()}
          darkMode={darkMode}
          hideHomeIcon={hideHeader}
          hideAccountIcon={hideHeader}
          showFullHeader={true}
        />
        {!showErrorModal && (
          <>
            {pageLoader
              ? this.showPageLoader()
              : webView
              ? this.renderWebPage()
              : this.renderAppPage()}
            {showUparrow && (
              <View
                style={{
                  position: webView ? "fixed" : "absolute",
                  bottom: 20,
                  right: 0,
                  zIndex: 2,
                }}
              >
                <TouchableOpacity
                  onPress={() => this.scrollToTop()}
                  activeOpacity={0.8}
                  style={{ paddingHorizontal: 10, paddingVertical: 10 }}
                >
                  <CustomImage
                    source={upArrowIcon}
                    require={true}
                    style={{ width: 60, height: 60 }}
                    webStyle={{ width: 60, height: 60 }}
                  />
                </TouchableOpacity>
              </View>
            )}
          </>
        )}

        {showErrorModal && (
          <ErrorModal
            goToHome={() => this.props.navigation.navigate("/")}
            tryAgain={() => this.getModalClickEvent()}
            show={showErrorModal}
          />
        )}
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  const { app, user } = state;
  return { app, user };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ removeUserToken }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Faq);

let Breadcrumbs = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "FAQ",
  },
];
